


















































































































import { AllGeeksSingleSelect } from '@/components';
import { GeekItem } from '@/models';
import { GeeksBalance, GeeksBalanceFilters } from '@/models/gcoins';
import { typedStore, Actions } from '@/store';
import { buildGeekName, download, ToastsService } from '@/utils';

import Vue from 'vue';

export default Vue.extend({
  name: 'GeeksBalanceTab',
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
      filters: {
        immediate: {
          geekId: '',
          showOnlyActive: true,
        } as GeeksBalanceFilters,
      },
    };
  },
  components: {
    AllGeeksSingleSelect,
  },
  async created() {
    this.$store.dispatch(Actions.gCoins.fetchAllGeeksBalance);
    this.fetchGeeksBalances();
  },
  computed: {
    balanceEntries(): GeeksBalance[] {
      return typedStore(this).state.gCoins.balanceEntries;
    },
    allGeeksBalance(): number {
      return typedStore(this).state.gCoins.allGeeksBalance;
    },
    areMoreItemsAvailable(): boolean {
      return this.balanceEntries.length
        < typedStore(this).state.gCoins.pagination.totalCount
        && this.balanceEntries.length > 0;
    },
  },
  methods: {
    async fetchGeeksBalances() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.gCoins.fetchGeeksBalanceEntries,
          { ...this.filters.immediate },
        );
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    async fetchMore() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(
          Actions.gCoins.fetchMoreBalanceEntries,
          { ...this.filters.immediate },
        );
      } finally {
      this.loader.isRequestPending = false;
      }
    },
    async fetchBalances() {
      const fileContent = await this.$store.dispatch(Actions.gCoins.fetchBalances);
      download(
        'LoG-geeks_balances_report.xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/xlsx',
        fileContent,
      );
      ToastsService.success(this.$t('admin-panel.gcoins.labels.download-report-success') as string);
    },
    updateGeekId(selectedGeek: GeekItem) {
      this.filters.immediate.geekId = selectedGeek ? selectedGeek.id : (null as unknown) as string;
    },
    buildGeekName,
  },
  watch: {
    'filters.immediate': {
      handler(this: any) {
        this.fetchGeeksBalances();
      },
      deep: true,
    },
  },
});
